import React, { useState } from "react";
import { Bot, Loader2, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { LOGIN } from "@/constants/testIds/auth";

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (enviando) return;
    setErro("");
    setEnviando(true);
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      const status = err?.response?.status;
      setErro(
        status === 401
          ? "E-mail ou senha inválidos."
          : status === 403
          ? "Este usuário está desativado."
          : err?.response?.data?.detail ||
            "Não consegui falar com o servidor. Ele está no ar e o endereço está certo?"
      );
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-secondary/30 px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Bot className="h-5 w-5" />
          </div>
          <div>
            <div className="font-heading text-lg font-semibold leading-tight">AtendeAI Console</div>
            <div className="text-xs text-muted-foreground">Entre para continuar</div>
          </div>
        </div>

        <Card>
          <CardContent className="p-5">
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="username"
                  autoFocus
                  required
                  className="mt-1.5"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid={LOGIN.emailInput}
                />
              </div>
              <div>
                <Label htmlFor="password">Senha</Label>
                <Input
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="mt-1.5"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid={LOGIN.passwordInput}
                />
              </div>

              {erro && (
                <p role="alert" className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">
                  {erro}
                </p>
              )}

              <Button type="submit" className="w-full" disabled={enviando} data-testid={LOGIN.submitButton}>
                {enviando ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <LogIn className="mr-2 h-4 w-4" />}
                {enviando ? "Entrando…" : "Entrar"}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="mt-4 text-center text-xs text-muted-foreground">
          O primeiro usuário é criado no boot do servidor, a partir de
          <span className="font-mono"> ADMIN_EMAIL</span> e
          <span className="font-mono"> ADMIN_PASSWORD</span>.
        </p>
      </div>
    </div>
  );
}
